import { categories } from '@/mocks/comics';

interface CategoryNavProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryNav({ activeCategory, onCategoryChange }: CategoryNavProps) {
  return (
    <section className="w-full bg-background-50 py-6">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              type="button"
              onClick={() => onCategoryChange(cat.slug)}
              className={`inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white shadow-sm'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
              }`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}